import { render } from "./buttonArea.vue?vue&type=template&id=0246b78a&scoped=true"
import script from "./buttonArea.vue?vue&type=script&lang=js"
export * from "./buttonArea.vue?vue&type=script&lang=js"

import "./buttonArea.vue?vue&type=style&index=0&id=0246b78a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0246b78a"]])

export default __exports__